export const hasFeature = (user, key) => user?.features?.[key] !== false;

export default hasFeature;
